import { getCookie } from '@picsart/rc/cookie';
import { L as Logger } from '../logger-4df3b60c.js';

var isValid = function isValid(gclid) {
  return gclid && new Date().getTime() < gclid.expiryDate;
};
var getGclidValue = function getGclidValue() {
  // this is being set with GTM
  var gclidString = localStorage.getItem('gclid');
  if (gclidString) {
    var gclid;
    try {
      gclid = JSON.parse(gclidString);
    } catch (error) {
      Logger.error(error);
    }
    if (isValid(gclid)) {
      return gclid.value;
    }
  }
};

// https://www.analyticsmania.com/post/google-analytics-client-id/
var getClientId = function getClientId() {
  var _getCookie;
  return (_getCookie = getCookie('_ga')) === null || _getCookie === void 0 ? void 0 : _getCookie.substring(6);
};
var googleClickIdService = {
  getGclidValue: getGclidValue,
  getClientId: getClientId
};

export { googleClickIdService as default, getClientId, getGclidValue, isValid };
//# sourceMappingURL=index.js.map
